import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { AuthenticationService } from '../../authentication/services/authentication.service';
import { EMPTY, Observable } from 'rxjs';
import { RuiterUserDto } from '../../api/api.service';
import { CurrentUserService } from '@core/authentication/services/current-user.service';
import { ViewAction } from '@antony/ng-ui';
import { PROFILE_VIEW_ACTIONS } from '@core/navigation/view-actions/injection-token';
import { environment } from '@env';
import { MatCard, MatCardAvatar, MatCardFooter, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { AsyncPipe, NgIf, SlicePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslatePipe } from '@ngx-translate/core';
import { MatActionList, MatListItem, MatListItemIcon, MatListItemTitle } from '@angular/material/list';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  imports: [
    MatCard,
    NgIf,
    MatCardAvatar,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatCardFooter,
    MatProgressSpinner,
    AsyncPipe,
    SlicePipe,
    TranslatePipe,
    MatListItem,
    MatListItemIcon,
    MatListItemTitle,
    MatActionList,
  ],
})
export class ProfileComponent implements OnInit {
  user$: Observable<RuiterUserDto | null> = EMPTY;
  readonly version = environment.version;

  @Output()
  closed = new EventEmitter();

  constructor(
    private authService: AuthenticationService,
    private currentUserService: CurrentUserService,
    @Inject(PROFILE_VIEW_ACTIONS)
    public viewActions: ViewAction[]
  ) {}

  ngOnInit() {
    this.user$ = this.currentUserService.getCurrentUser();
  }

  logout() {
    this.closed.emit();
    this.authService.logout().subscribe();
  }

  onViewActionClick(viewAction: ViewAction): void {
    this.closed.emit();
    viewAction.onClick();
  }
}
